import { render } from "./CompletedACPPage.vue?vue&type=template&id=cc2189b8"
import script from "./CompletedACPPage.vue?vue&type=script&lang=js"
export * from "./CompletedACPPage.vue?vue&type=script&lang=js"

import "./CompletedACPPage.vue?vue&type=style&index=0&id=cc2189b8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__